import { BrainLoadingIcon } from 'morpheus-ui';
import React, { useEffect, useRef, useState } from 'react';
import env from '../../../env';

interface SambaPlayerProps {
  token: string;
  loading?: boolean;
  virtualFinishAt?: number;
  onCreate?: (controls: any) => void;
  onStart?: () => void;
  onFinish?: () => void;
  onVirtualFinish?: () => void;
  onError?: () => void;
  onListen?: (event: any) => void;
  id?: string;
  initialTime?: number;
}

interface EventListener {
  onCreate?: (controls: any) => void;
  onLoad?: () => void;
  onStart?: () => void;
  onFinish?: () => void;
  onError?: (event: any) => void;
  onListen?: (event: any) => void;
}

const buildPlayer = (
  id: string,
  token: string,
  eventListener: EventListener,
  initialTime = 0
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return new window.SambaPlayer(id, {
    height: '465px',
    width: '100%',
    ph: env.REACT_APP_SAMBA_PH,
    m: token,
    playerParams: {
      enableShare: false,
      startOutput: '360p',
      resume: initialTime === 0,
      initialTime: initialTime,
    },
    events: eventListener,
  });
};

const SambaPlayer: React.FC<SambaPlayerProps> = ({
  loading,
  token,
  virtualFinishAt = 80,
  onCreate,
  onStart,
  onFinish,
  onVirtualFinish,
  onError,
  onListen,
  id = 'samba-selector',
  initialTime,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [firedVirtualFinish, setFiredVirtualFinish] = useState(false);
  const [listenEvent, setLastListenEvent] = useState<any>({});
  const videoPlayerRef = useRef<HTMLDivElement>(null);
  const playerInstance = useRef<any>(null);

  const eventListener: EventListener = {
    onCreate: (controls) => {
      onCreate && onCreate(controls);
    },
    onLoad: () => {
      setLoaded(true);
    },
    onStart: () => {
      onStart && onStart();
    },
    onFinish: () => {
      onFinish && onFinish();
    },
    onError: (event) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onError && onError(event);
    },
    onListen: (event) => {
      setLastListenEvent(event);
      onListen && onListen(event);
    },
  };

  useEffect(() => {
    if (token && !loading) {
      if (!playerInstance.current) {
        playerInstance.current = buildPlayer(
          id,
          token,
          eventListener,
          initialTime
        );
        setLoaded(true);
      }
    }
  }, [token, loading, id, eventListener]);

  useEffect(() => {
    if (onVirtualFinish && virtualFinishAt && !firedVirtualFinish) {
      const percentage = listenEvent.eventParam / (listenEvent.duration / 1000);
      if (percentage * 100 > virtualFinishAt) {
        setFiredVirtualFinish(true);
        onVirtualFinish();
      }
    }
  }, [listenEvent, virtualFinishAt, firedVirtualFinish, onVirtualFinish]);

  return (
    <div>
      <div ref={videoPlayerRef} id={id} className='h-full w-full'>
        {!loaded && (
          <BrainLoadingIcon className='h-20 w-20 animate-pulse stroke-brand-color-primary-pure stroke-2' />
        )}
      </div>
    </div>
  );
};

export default SambaPlayer;
